export const i18n = {
  locales: ["fr", "en"] as const,
  defaultLocale: "fr" as const,
} as const;

export type Locale = (typeof i18n.locales)[number];

export function isLocale(input: string): input is Locale {
  return (i18n.locales as readonly string[]).includes(input);
}

/**
 * Le français vit à la racine (`/nos-valeurs`) pour préserver les URLs
 * historiques du site WordPress ; l'anglais est préfixé (`/en/nos-valeurs`).
 */
export function localePath(locale: Locale, path: string): string {
  const clean = path === "/" ? "" : path;
  return locale === "fr" ? clean || "/" : `/en${clean}`;
}

/** Chemin équivalent dans l'autre langue, pour le sélecteur FR/EN. */
export function switchLocalePath(current: string, target: Locale): string {
  const withoutPrefix = current.replace(/^\/en(?=\/|$)/, "") || "/";
  return localePath(target, withoutPrefix);
}
